import React from 'react';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import {bindActionCreators} from '@reduxjs/toolkit';

import type {AppDispatch, RootState} from '../store';
import {photoBoxActions} from '../store/slices/photoBox/photoBox.slice';
import {paymentsActions} from '../store/slices/payments';
import {bookExperienceActions} from 'store/slices/bookExperience';
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch<AppDispatch>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

const actions = {
  ...photoBoxActions,
  ...paymentsActions,
  ...bookExperienceActions,
};

export const useActions = () => {
  const dispatch = useAppDispatch();

  return React.useMemo(() => bindActionCreators(actions, dispatch), [dispatch]);
};
